import * as React from 'react';
import {
    Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button, Container, Row, Col, Alert, Spinner
} from 'reactstrap';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as UserStore from '../../store/User';
import { Route, RouteComponentProps } from 'react-router';
import { isNullOrUndefined } from 'util';
import { SessionModel } from '../../models/SessionModel';
import { SaDate, SaLabel } from '../Misc/SawinComponents';
import * as myCfg from '../../AppConfig';
import { Link } from 'react-router-dom';

type LogInProps =
    UserStore.UserState &
    SessionModel &
    typeof UserStore.actionCreators
    & RouteComponentProps<{ startDateIndex: string }>; // ... plus incoming routing parameters

class LogIn extends React.PureComponent<LogInProps> {

    state: UserStore.UserState = UserStore.initialState;
    CompanyName?: string | null = "";

    constructor(props: LogInProps) {
        super(props);     

        this.CompanyName = localStorage.getItem("Company");
        if (isNullOrUndefined(this.CompanyName)) {
            return;
        }
        
    }
           
    componentDidMount() {
      
        var myLocal = localStorage.getItem("UserStored");
        if (myLocal) {            
            var myLocalObject = JSON.parse(myLocal);
            myLocalObject.triggerFrom = "LOCALSTORAGE";
            this.props.validateAuthCode(myLocalObject);   
        }                   
    }
  
    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };

    handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();        
        this.props.validatePhone(this.state);
    };

    handleSubmitAuthCode = (e: React.FormEvent) => {
        e.preventDefault();
        this.props.validateAuthCode(this.state);
    };

    requestAccess = (e: React.MouseEvent) => {
        this.props.requestAccess(true);
    }

    public render() {
 
        let NextButton;

        if (this.props.isProcessing) {
            NextButton = <span>Processing <Spinner size="sm" color="primary" /></span>;
        } else {
            if (this.props.IsPhoneValid) {
                NextButton = <Button>Log In</Button>;
            } else {
                NextButton = <Button>Next</Button>;
            }
        }

        if (!this.CompanyName) {
            return (<div>Company not set up</div>);
        } else {
            if (this.props.IsPhoneValid) {
                return (
                    <React.Fragment>
                        <div className="logInPositionDiv">
                           
                            <form onSubmit={this.handleSubmitAuthCode}>
                                <Card className="logInCard">
                                    <CardImg src={`/img/logos/${this.CompanyName}.png` }></CardImg>
                                    <CardBody>                                        
                                        <Row className="p-2">
                                            <Col>Enter the verification code you received on your phone or email <br/><input className="form-control" type="number" name="Password" id="Password" value={this.state.Password} onChange={this.handleChange} /></Col>
                                        </Row>
                                        <Row className="p-2">
                                            <Col className="text-right">                                                
                                                {NextButton}
                                            </Col>
                                        </Row>
                                        {this.props.LogInError !== "" ? <Row><Col><Alert>{this.props.LogInError}</Alert></Col></Row> : ""}
                                        <Row><Col>{myCfg.appVersion}</Col></Row>
                                    </CardBody>
                                </Card>
                            </form>
                        </div>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <div className="logInPositionDiv">
                            <form onSubmit={this.handleSubmit}>
                                <Card className="logInCard">
                                    <CardImg src={`/img/logos/${this.CompanyName}.png`}></CardImg>
                                    <CardBody>
                                        <Row className="p-2">
                                            <Col>
                                                Phone or Email
                                                <input className="form-control" type="text" name="Phone" id="Phone" value={this.state.Phone} onChange={this.handleChange} />
                                            </Col>
                                        </Row>
                                        <Row className="p-2">
                                            <Col className="text-right">
                                                {NextButton}
                                            </Col>
                                        </Row>
                                        {this.props.LogInError !== "" ? <Row><Col><Alert>{this.props.LogInError}</Alert></Col></Row> : ""}
                                        <Row><Col>{myCfg.appVersion}</Col></Row>
                                        <Row><Col> <br/> <div className='callHistoryInvoiceLink' onClick={this.requestAccess} >Request Access </div> </Col></Row>
                                    </CardBody>
                                </Card>
                            </form>
                        </div>
                    </React.Fragment>
                );
            }
        }
      

    }

};

export default connect((state: ApplicationState) => ({ ...state.user, ...state.sessionState }),UserStore.actionCreators)(LogIn as any);